export function defaultEmptySelection() {
    return '*** Em branco ***'
}